import { useDataChange } from 'Simple/Data.js'

export default function useListItemDataOnChange(props) {
  let change = useDataChange({
    context: 'event_action',
    viewPath: props.viewPath,
  })

  return function onChange(next) {
    change(inext => {
      inext.data = {
        ...inext.data,
        actions: [next],
      }
    })
  }
}
